export default "__VITE_ASSET__BXobytav__"